import AuthController from "@/controllers/AuthController"
import ProfileController from "@/controllers/ProfileController"
import CompanyController from "@/controllers/CompanyController"
import ConnectionsController from "@/controllers/ConnectionsController"
import ContactsController from "@/controllers/ContactsController"
import ChatImportController from "@/controllers/ChatImportController"
import DepartmentController from "@/controllers/DepartmentController"
import MessagesController from "@/controllers/MessagesController"
import QueuesController from "@/controllers/QueuesController"
import QueuesOptionsController from "@/controllers/QueuesOptionsController"
import TemplateController from "@/controllers/TemplateController"
import TicketsController from "@/controllers/TicketsController"
import UsersController from "@/controllers/UsersController"
import DashboardController from "@/controllers/DashboardController"
import IssuesController from "@/controllers/IssuesController"
import InternalChatController from "@/controllers/InternalChatController"
import QuickMessagesController from "@/controllers/QuickMessagesController"
import SettingsController from "@/controllers/SettingsController"
import TagsController from "@/controllers/TagsController"
import PlanController from "@/controllers/PlanController"
import BancosController from "@/controllers/BancosController"
import FiscalConfigController from "@/controllers/FiscalConfigController"
import ScheduledMessagesController from "@/controllers/ScheduledMessagesController"
import ReceivableController from "@/controllers/ReceivableController"
import CampaignsController from "@/controllers/CampaignsController"

const routes = {
  AuthController,
  ProfileController,
  CompanyController,
  ConnectionsController,
  ContactsController,
  ChatImportController,
  DepartmentController,
  MessagesController,
  QueuesController,
  QueuesOptionsController,
  TemplateController,
  TicketsController,
  UsersController,
  DashboardController,
  IssuesController,
  InternalChatController,
  QuickMessagesController,
  SettingsController,
  TagsController,
  PlanController,
  BancosController,
  FiscalConfigController,
  ScheduledMessagesController,
  ReceivableController,
  CampaignsController,
}


export default routes;